import * as RxSelect from "@radix-ui/react-select";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";
import { MdArrowDropDown } from "react-icons/md";

import ButtonSecondary from "../ButtonSecondary";

import styles from "./index.module.scss";

type Size = `${number}px`;

export type Option<T> = {
  label: React.ReactNode;
  value: T;
};

type Props<T> = {
  className?: string;
  style?: React.CSSProperties;
  options: Option<T>[];
  minContentWidth?: Size;
  maxContentWidth?: Size;
  minButtonWidth?: Size;
  maxButtonWidth?: Size;
  value: T;
  onChange?: (value: T) => void;
  labelWhenEmpty?: React.ReactNode;
  disabled?: boolean;
};

export default function Select<T extends string>({
  className,
  style,
  options,
  minContentWidth,
  maxContentWidth,
  minButtonWidth,
  maxButtonWidth,
  value,
  onChange,
  labelWhenEmpty,
  disabled,
}: Props<T>) {
  const selectedOption = options.find((option) => option.value === value);

  return (
    <div className={className} style={style}>
      <RxSelect.Root
        value={value}
        onValueChange={(value) => {
          const matchedOption = options.find(
            (option) => option.value === value
          );
          matchedOption && onChange?.(matchedOption.value);
        }}
        disabled={disabled}
      >
        <RxSelect.Trigger asChild>
          <ButtonSecondary size="md">
            <Flex.Row
              gap="8px"
              justifyContent="space-between"
              alignItems="center"
              style={{ textTransform: "none" }}
              maxWidth={maxButtonWidth}
              minWidth={minButtonWidth}
            >
              <RxSelect.Value asChild>
                <Flex.Cell flex="1 1 auto" minWidth="0">
                  {selectedOption ? selectedOption.label : labelWhenEmpty}
                </Flex.Cell>
              </RxSelect.Value>
              <RxSelect.Icon asChild>
                <Flex.Cell flex="0 0 auto" asChild>
                  <MdArrowDropDown size="24px" style={{ margin: "-7px" }} />
                </Flex.Cell>
              </RxSelect.Icon>
            </Flex.Row>
          </ButtonSecondary>
        </RxSelect.Trigger>
        <RxSelect.Portal>
          <RxSelect.Content
            className={styles.content}
            position="popper"
            style={{ minWidth: minContentWidth, maxWidth: maxContentWidth }}
          >
            <RxSelect.Viewport className={styles.viewport}>
              <Flex.Col>
                {options.map(({ value, label }) => (
                  <RxSelect.Item asChild key={value} value={value}>
                    <button className={styles.item}>
                      <RxSelect.ItemText>{label}</RxSelect.ItemText>
                    </button>
                  </RxSelect.Item>
                ))}
              </Flex.Col>
            </RxSelect.Viewport>
          </RxSelect.Content>
        </RxSelect.Portal>
      </RxSelect.Root>
    </div>
  );
}
